import React,{useEffect,useState} from "react";
import Head from "../Header/head";
import "./completion.css";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../services/axios";
import { useParams } from 'react-router-dom';

function Completion(props) {
    const navigate = useNavigate();
    const [countdown,setcountdown] = useState(3);
    const payment_intent  = useParams();
    console.log(payment_intent)
    // alert(payment_intent)

    const startCountdown = ()=>{
        const countdowninterval = setInterval(()=>{
            setcountdown((prevCountdown) => prevCountdown - 1);
        },1000);
    }
    const fetch_data = async (paymentIntent) =>{
        const {data} = await axiosInstance.get(`/subscription/confirm-payment/${paymentIntent}`) 
        console.log(data.status,"status")
    }   
    useEffect(()=>{
        const searchParams = new URLSearchParams(window.location.search);
        const paymentIntent = searchParams.get('payment_intent');
        const clientSecret = searchParams.get('payment_intent_client_secret');
        const redirectStatus = searchParams.get('redirect_status');
        console.log('Payment Intent:', paymentIntent);
        console.log('Client Secret:', clientSecret);
        console.log('Redirect Status:', redirectStatus);

        if (redirectStatus === 'succeeded') {
            fetch_data(paymentIntent)
        } else {
        // Handle other cases
        }

    },[]);

    setTimeout(()=>{
        navigate("/")
    },3000);

    return (
        <>
            {/* <Head/> */}
            <div className="confirmation">
            <div class="confirmation-container">
                <div class="success-message">Payment Successful!</div>
                <div class="thank-you-message">Thank you for your purchase. Your payment has been processed. {countdown > 0 && <p>Redirecting in {countdown} seconds...</p>}!!</div>
            </div>
            </div>
        </>
    
    );
  }
  
  export default Completion;
  